const translations = {
  ar: {
    // Navbar
    navbar: {
      about: 'حول التطبيق',
      download: 'تحميل التطبيق'
    },
    
    // Header
    header: {
      title: 'بوابة الليطاني',
      subtitle: 'المنصة الرقمية الرسمية المعتمدة للمواطنين للوصول إلى خدمات البلدة بسرعة وسهولة',
      downloadBtn: 'تحميل التطبيق'
    },
    
    // About
    about: {
      title: 'بوابة الليطاني',
      description: 'المنصة الرقمية الرسمية المعتمدة للمواطنين للوصول إلى خدمات البلدة بسرعة وسهولة',
      officiallyApproved: '✅ معتمد رسمياً من البلدية',
      licenseNote: '(يمكن الاطلاع على وثيقة الترخيص داخل التطبيق)',
      keyFeatures: 'المميزات الرئيسية',
      features: {
        news: {
          title: 'الأخبار والإعلانات',
          description: 'تحديثات فورية حول النشاطات البلدية والأحداث المحلية'
        },
        bills: {
          title: 'دفع الفواتير',
          description: 'عرض فواتير الكهرباء والمياه وخدمات أخرى (حسب التوفر)'
        },
        notifications: {
          title: 'التنبيهات الفورية',
          description: 'تلقي تنبيهات عاجلة للطوارئ أو الخدمات الجديدة'
        },
        emergency: {
          title: 'جهات الاتصال الطارئة',
          description: 'الوصول المباشر إلى الدفاع المدني والشرطة والخطوط الساخنة للبلدية'
        },
        council: {
          title: 'أعضاء المجلس',
          description: 'ملفات تعريفية وأدوار ممثلي المجلس البلدي'
        },
        contact: {
          title: 'نموذج الاتصال',
          description: 'تقديم الشكاوى والاقتراحات أو الاستفسارات مباشرة إلى البلدية'
        },
        faq: {
          title: 'الأسئلة الشائعة',
          description: 'إجابات سريعة على الأسئلة الشائعة من المواطنين'
        }
      }
    },
    
    // FAQ
    faq: {
      title: 'الأسئلة الشائعة',
      subtitle: 'إجابات سريعة على الأسئلة الأكثر شيوعاً حول التطبيق وخدماته',
      questions: [
        {
          question: "كيف يمكنني تحميل التطبيق؟",
          answer: "يمكنك تحميل التطبيق من متجر Google Play أو App Store. ابحث عن 'بوابة الليطاني' أو استخدم رمز QR الموجود في الصفحة."
        },
        {
          question: "هل التطبيق مجاني؟",
          answer: "نعم، التطبيق مجاني تماماً ولا يتطلب أي رسوم للتحميل أو الاستخدام."
        },
        {
          question: "ما هي الخدمات المتوفرة؟",
          answer: "التطبيق يوفر الأخبار البلدية، عرض الفواتير، معلومات الاتصال، والتواصل مع البلدية وخدمات أخرى متنوعة."
        },
        {
          question: "كيف أحصل على الدعم الفني؟",
          answer: "يمكنك التواصل معنا عبر البريد الإلكتروني Info@QaqaaiyatAlJiser.com أو من خلال نموذج الاتصال في التطبيق مباشرة."
        },
        {
          question: "هل معلوماتي الشخصية آمنة؟",
          answer: "نعم، نلتزم بحماية خصوصيتك وفقاً لسياسة الخصوصية المعتمدة. جميع البيانات محمية بأعلى معايير الأمان."
        }
      ]
    },
    
    // Statistics
    statistics: {
      title: 'أرقام تتحدث عن نفسها',
      subtitle: 'إحصائيات حول استخدام التطبيق ومدى رضا المواطنين',
      stats: {
        citizens: {
          number: 2500,
          label: 'مواطن مسجل',
          suffix: '+'
        },
        services: {
          number: 15,
          label: 'خدمة متاحة',
          suffix: ''
        },
        downloads: {
          number: 1200,
          label: 'تحميل للتطبيق',
          suffix: '+'
        },
        satisfaction: {
          number: 98,
          label: '% رضا المستخدمين',
          suffix: '%'
        }
      }
    },
    
    // Download
    download: {
      title: 'تحميل التطبيق الرسمي',
      description: 'احصل على تطبيق بوابة الليطاني الرسمي المعتمد على المنصة المفضلة لديك واستخدم جميع الخدمات البلدية فوراً',
      appPreview: 'معاينة التطبيق',
      choosePlatform: 'اختر منصتك',
      qrTitle: 'الوصول السريع برمز QR',
      qrDescription: 'امسح بكاميرا هاتفك للوصول الفوري إلى التطبيق الإلكتروني',
      availableOn: 'تطبيقات الجوال الرسمية متوفرة على جوجل بلاي وآب ستور. النسخة الإلكترونية متاحة عبر رمز QR أعلاه',
      webAppText: 'أو استخدم التطبيق فوراً على الويب:',
      openWebApp: '🌐 افتح التطبيق الإلكتروني',
      screenshots: {
        homepage: 'الصفحة الرئيسية',
        news: 'الأخبار والتحديثات',
        bills: 'الفواتير والخدمات',
        contact: 'التواصل والدعم'
      }
    },
    
    // Privacy Policy
    privacy: {
      title: 'سياسة الخصوصية',
      lastUpdated: 'آخر تحديث: يناير 2025',
      introduction: 'تلتزم بلدية قاقعية الجسر بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك الشخصية عند استخدام تطبيق بوابة الليطاني.',
      sections: {
        dataCollection: {
          title: 'جمع البيانات',
          content: 'نقوم بجمع المعلومات التي تقدمها لنا مباشرة، مثل عندما تتواصل معنا عبر التطبيق أو تقدم ملاحظات. قد تشمل هذه المعلومات اسمك ومعلومات الاتصال ومحتوى الرسالة.'
        },
        dataUsage: {
          title: 'كيفية استخدام بياناتك',
          content: 'نستخدم المعلومات التي نجمعها لتقديم وتحسين خدماتنا، والرد على استفساراتك، والتواصل معك حول خدمات البلدية والتحديثات.'
        },
        dataSharing: {
          title: 'مشاركة البيانات',
          content: 'لا نبيع أو نتاجر أو ننقل معلوماتك الشخصية إلى أطراف ثالثة دون موافقتك، باستثناء ما هو موضح في هذه السياسة أو كما يتطلبه القانون.'
        },
        dataSecurity: {
          title: 'أمان البيانات',
          content: 'نطبق تدابير أمنية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التغيير أو الكشف أو التدمير.'
        },
        thirdParty: {
          title: 'الخدمات الخارجية',
          content: 'قد يحتوي تطبيقنا على روابط لخدمات طرف ثالث. نحن لسنا مسؤولين عن ممارسات الخصوصية لهذه الخدمات الخارجية.'
        },
        userRights: {
          title: 'حقوقك',
          content: 'لديك الحق في الوصول إلى معلوماتك الشخصية أو تحديثها أو حذفها. يمكنك أيضاً إلغاء الاشتراك في بعض الاتصالات منا.'
        },
        childrenPrivacy: {
          title: 'خصوصية الأطفال',
          content: 'خدمتنا غير مخصصة للأطفال دون سن 13 عاماً. نحن لا نجمع عمداً معلومات شخصية من الأطفال دون سن 13 عاماً.'
        },
        policyChanges: {
          title: 'تغييرات السياسة',
          content: 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات عن طريق نشر السياسة الجديدة في التطبيق.'
        }
      },
      contact: {
        title: 'تواصل معنا',
        description: 'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى التواصل معنا:',
        municipality: 'بلدية قاقعية الجسر',
        phone: '+961 XX XXX XXX',
        email: 'Info@QaqaaiyatAlJiser.com',
        emailSubject: 'استفسار حول سياسة الخصوصية'
      },
      footer: {
        appName: 'بوابة الليطاني',
        developer: 'تطوير: شميساني مصطفى'
      }
    },
    
    // Footer
    footer: {
      copyright: 'بلدية قاقعية الجسر. جميع الحقوق محفوظة',
      contact: 'للاستفسارات:'
    }
  },
  
  en: {
    // Navbar
    navbar: {
      about: 'About',
      download: 'Download'
    },
    
    // Header
    header: {
      title: 'Litani Gateway',
      subtitle: 'The official certified digital platform for residents to access municipal services and stay updated with announcements—quickly and effortlessly',
      downloadBtn: 'Download App'
    },
    
    // About
    about: {
      title: 'Litani Gateway',
      description: 'The official certified application of Qaqaaiyat Al Jiser Municipality, designed as a digital platform for residents to access municipal services and stay updated with the latest announcements—quickly and effortlessly.',
      officiallyApproved: '✅ Officially Approved by the Municipality',
      licenseNote: '(The license document can be viewed in-app)',
      keyFeatures: 'Key Features',
      features: {
        news: {
          title: 'News & Announcements',
          description: 'Real-time updates on municipal activities and local events'
        },
        bills: {
          title: 'Bill Payments',
          description: 'View electricity, water, and other service bills (where available)'
        },
        notifications: {
          title: 'Instant Notifications',
          description: 'Receive urgent alerts for emergencies or new services'
        },
        emergency: {
          title: 'Emergency Contacts',
          description: 'Direct access to civil defense, police, and municipality hotlines'
        },
        council: {
          title: 'Council Members',
          description: 'Profiles and roles of the municipal council representatives'
        },
        contact: {
          title: 'Contact Form',
          description: 'Submit complaints, suggestions, or inquiries directly to the municipality'
        },
        faq: {
          title: 'FAQ Section',
          description: 'Quick answers to common questions from residents'
        }
      }
    },
    
    // FAQ
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Quick answers to the most common questions about the app and its services',
      questions: [
        {
          question: "How can I download the app?",
          answer: "You can download the app from Google Play Store or App Store. Search for 'Litani Gateway' or use the QR code on the page."
        },
        {
          question: "Is the app free?",
          answer: "Yes, the app is completely free and doesn't require any fees for download or usage."
        },
        {
          question: "What services are available?",
          answer: "The app provides municipal news, bill viewing, contact information, direct communication with the municipality, and various other services."
        },
        {
          question: "How do I get technical support?",
          answer: "You can contact us via email at Info@QaqaaiyatAlJiser.com or directly through the contact form in the app."
        },
        {
          question: "Is my personal information safe?",
          answer: "Yes, we are committed to protecting your privacy according to our adopted privacy policy. All data is protected with the highest security standards."
        }
      ]
    },
    
    // Statistics
    statistics: {
      title: 'Numbers That Speak for Themselves',
      subtitle: 'Statistics about app usage and citizen satisfaction',
      stats: {
        citizens: {
          number: 2500,
          label: 'Registered Citizens',
          suffix: '+'
        },
        services: {
          number: 15,
          label: 'Available Services',
          suffix: ''
        },
        downloads: {
          number: 1200,
          label: 'App Downloads',
          suffix: '+'
        },
        satisfaction: {
          number: 98,
          label: '% User Satisfaction',
          suffix: '%'
        }
      }
    },
    
    // Download
    download: {
      title: 'Download the Official App',
      description: 'Get the officially certified Litani Gateway app on your preferred platform and access all municipal services instantly',
      appPreview: 'App Preview',
      choosePlatform: 'Choose Your Platform',
      qrTitle: 'Quick Access with QR Code',
      qrDescription: 'Scan with your phone camera to access the web app instantly',
      availableOn: 'Official mobile apps available on Google Play and App Store. Web version accessible via QR code above',
      webAppText: 'Or access instantly on the web:',
      openWebApp: '🌐 Open Web App',
      screenshots: {
        homepage: 'Homepage',
        news: 'News & Updates',
        bills: 'Bills & Services',
        contact: 'Contact & Support'
      }
    },
    
    // Privacy Policy
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: January 2025',
      introduction: 'Qaqaaiyat Al Jiser Municipality is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use the Litani Gateway app.',
      sections: {
        dataCollection: {
          title: 'Data Collection',
          content: 'We collect information you provide directly to us, such as when you contact us through the app or submit feedback. This may include your name, contact information, and message content.'
        },
        dataUsage: {
          title: 'How We Use Your Data',
          content: 'We use the information we collect to provide and improve our services, respond to your inquiries, and communicate with you about municipality services and updates.'
        },
        dataSharing: {
          title: 'Data Sharing',
          content: 'We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy or as required by law.'
        },
        dataSecurity: {
          title: 'Data Security',
          content: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.'
        },
        thirdParty: {
          title: 'Third-Party Services',
          content: 'Our app may contain links to third-party services. We are not responsible for the privacy practices of these external services.'
        },
        userRights: {
          title: 'Your Rights',
          content: 'You have the right to access, update, or delete your personal information. You may also opt out of certain communications from us.'
        },
        childrenPrivacy: {
          title: "Children's Privacy",
          content: 'Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13.'
        },
        policyChanges: {
          title: 'Policy Changes',
          content: 'We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy in the app.'
        }
      },
      contact: {
        title: 'Contact Us',
        description: 'If you have any questions about this Privacy Policy, please contact us:',
        municipality: 'Qaqaaiyat Al Jiser Municipality',
        phone: '+961 XX XXX XXX',
        email: 'Info@QaqaaiyatAlJiser.com',
        emailSubject: 'Privacy Policy Inquiry'
      },
      footer: {
        appName: 'Litani Gateway',
        developer: 'Developed by Shmaisany Mostafa'
      }
    },
    
    // Footer
    footer: {
      copyright: 'Qaqaaiyat Al Jiser Municipality. All rights reserved',
      contact: 'For inquiries:'
    }
  }
};

export default translations;
